import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LinearProgress from '@mui/material/LinearProgress';
import './login.css'
import Textfield from '@atlaskit/textfield';
import FormControl from '@mui/material/FormControl';
import Navbar from '../navbar/navbar'
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Diversity1 } from '@mui/icons-material';
import {setUserSession,getToken,setSessionId} from '../util'
import { Navigate } from "react-router-dom"
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';

export default class Login extends React.Component{
  constructor(props){
    super(props)
    this.state={  
      modelOpen:false,
      redirect:false,
      directadmin:false,
      email:'',
      password:'',
      adminChecked:false,
      customerChecked:true,
      progress:false,
      data:''
    }
  }

  viewPage=()=>{
    this.setState({directadmin:true})
  } 
  onModelClick=()=>{
    this.setState({modelOpen:true})
  }
  onModelCose=()=>{
    this.setState({modelOpen:false,})
  }
  validateEmail=(email)=> {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  onAdminLogin=()=>{
    if(this.state.email===''||this.state.password===''){
      alert('All Inputs Are Required')
    }else if(!this.validateEmail(this.state.email)){
      alert('Please Enter Valid MailId')
    }
    else{
      let json_data={emailId:this.state.email,password:this.state.password}
      fetch(`eadmin/v1/set/admin_login`, {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.status){
          setUserSession(responseJson.token, responseJson.result)
          setSessionId(responseJson.sessionId)
          localStorage.setItem('login', 'admin');
          this.getLicenseDetails()
          this.setState({redirect:true})
        }else{
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        alert(error)
      });
    }
  }
   getLicenseDetails=()=>{
    let data=[]
    fetch(`eadmin/v1/set/get_user_not_generate_license`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken(),
      },
      }).then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.status && responseJson.result.length>0){
        let id=1
        for(var i=0;i<responseJson.result.length;i++){
          let tempdata={...responseJson.result[i],id:id,}
          id++
          data.push(tempdata)
        }
        let len=data.length
        //alert(data.length)
        localStorage.setItem('length',JSON.stringify(len))
      }else if(!responseJson.status){
        alert(responseJson.errorMsg)
      }
    }).catch((error) => {
      alert(error)
    });
  }
    render(){
      return(
      <>
        <Navbar customer={true} buttonClick={this.viewPage}/><br/><br/><br/><br/>
        <div class="login-wrap">
          {this.state.progress && <LinearProgress color="secondary"/>}
          <div class="login-html">
            {this.props.admin?true:false}
              <input id="tab-1" type="radio" name="tab" class="sign-in" /><label for="tab-1" class="tab"> </label>
              <input id="tab-2" type="radio" name="tab" class="sign-up"  defaultChecked/><label for="tab-2" class="tab">ADMIN LOGIN </label>
              <div class="login-form">
                <div class="sign-up-htm">
                  <div class="group">
                    <label for="user" class="label">EmailId</label>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <Textfield aria-label="default text field" value={this.state.email} onChange={(evt)=>this.setState({email:evt.target.value})}/>
                      </FormControl>
                  </div>
                  <div class="group">
                    <label for="pass" class="label">Password</label>
                      <FormControl sx={{ m:1, width: '95%' }}>
                        <Textfield  aria-label="default text field" type="password"  data-type="password" value={this.state.password} onChange={(evt)=>this.setState({password:evt.target.value})}/>
                      </FormControl>
                  </div>
                  <div class="group">
                    <input type="submit" class="button" value="Log in" onClick={this.onAdminLogin}/>
                  </div>
                  <div class="hr"></div>
                </div>
              </div>
          </div>
        </div>
        <ModalTransition>
          {this.state.modelOpen && (
            <Modal onClose={this.onModelCose} >
              <ModalHeader>
                <ModalTitle>LogIn</ModalTitle>
              </ModalHeader>
              <ModalBody>
                <label>Do You Want To ReSend ythe Activate link </label>
              </ModalBody>
              <ModalFooter>
                <Button appearance="primary" onClick={this.OnMailLink} autoFocus>OK</Button>
                <Button appearance="primary" onClick={this.onModelCose} autoFocus>Cancel</Button>
              </ModalFooter>
            </Modal>
          )}
        </ModalTransition>
        { 
          this.state.redirect &&  window.location.replace("/dashboard")
        }
        { 
          this.state.directadmin && <Navigate to='/login' replace={true}/>
        }
	    </>
    )
  }
}